import SparkMD5 from 'spark-md5'
import { MessageBox, Message } from 'element-ui'
import VueRouter from 'vue-router'
import protocolCheck from './protocolCheck'
import Cookies from 'js-cookie'
export interface FilePathName {
    [key: string]: string
}
export function downloadFile(data: Blob, fileName: string) {
    // @ts-ignore
    if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(data, fileName)
    } else {
        let link = document.createElement('a')
        let evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', false, false)
        link.href = URL.createObjectURL(data)
        link.download = fileName
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
    }
}
// 业务无关的函数
export function getFileIcon(path: string): string {
    const imgTypes = ['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp']
    const vedioTypes = [
        'mp4',
        'm4v',
        'mov',
        'qt',
        'avi',
        'flv',
        'wmv',
        'asf',
        'mpeg',
        'mpg',
        'vob',
        'mkv',
        'asf',
        'rm',
        'rmvb',
        'vob',
        'dat',
    ]
    const docTypes = ['doc', 'docx', 'docm', 'dotx', 'dotm']
    const pptTypes = ['ppt', 'pptx', 'pptm', 'ppsx', 'ppsx', 'potx', 'potm', 'ppam']
    const excelTypes = ['xlsx', 'xlsm', 'xltx', 'xltm', 'xlsb', 'xlam', 'xls', 'csv']
    const zipTypes = [
        'rar',
        'tar',
        'zip',
        'gzip',
        'gz',
        'cab',
        'uue',
        'ajr',
        'bz2',
        'lzh',
        'jar',
        'ace',
        'iso',
        '7z',
        'z',
        'wim',
        'xz',
    ]
    const reg = /.*\.(.*)$/
    if (!reg.exec(path)) {
        return 'unknown'
    }
    const extName = reg.exec(path)![1].toLocaleLowerCase()

    if (imgTypes.includes(extName)) {
        return 'img'
    }
    if (vedioTypes.includes(extName)) {
        return 'vedio'
    }
    if (docTypes.includes(extName)) {
        return 'doc'
    }
    if (pptTypes.includes(extName)) {
        return 'ppt'
    }
    if (excelTypes.includes(extName)) {
        return 'excel'
    }
    if (extName === 'html') {
        return 'html'
    }
    if (extName === 'js') {
        return 'js'
    }
    if (extName === 'json') {
        return 'json'
    }
    if (extName === 'jsx' || extName === 'tsx') {
        return 'jsx'
    }
    if (extName === 'ts') {
        return 'ts'
    }
    if (extName === 'vue') {
        return 'vue'
    }
    if (zipTypes.includes(extName)) {
        return 'zip'
    }
    return 'unknown'
}

export function isImage(path: string): boolean {
    let isImg = false
    const imgTypes = ['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp']
    const reg = /.*\.(.*)$/
    if (reg.exec(path)) {
        const extName = reg.exec(path)![1].toLocaleLowerCase()
        if (imgTypes.includes(extName)) {
            isImg = true
        }
    }
    return isImg
}

export function getEllipsisString(str: string, n = 20) {
    if (!str) return ''
    return str.length < n + 1 ? str : `${str.substr(0, n)}...`
}

export async function computeMD5(file: any) {
    const { type, size, lastModified } = file.file
    file.pause()

    const chunkSize = 1 * 1024 * 1024
    const fileReader = new FileReader()
    const chunks = Math.ceil(file.size / chunkSize)
    const spark = new SparkMD5()
    spark.append(JSON.stringify({ type, size, lastModified }))
    const blobSlice =
        File.prototype.slice ||
        ((File.prototype as any).mozSlice as Function) ||
        ((File.prototype as any).webkitSlice as Function)

    let currentChunk = 0
    async function loadNext() {
        const start = currentChunk * chunkSize
        const isLastChunk = start + chunkSize >= file.size
        const end = isLastChunk ? file.size : start + chunkSize
        const slice = blobSlice.call(file.file, start, end)
        await fileReader.readAsBinaryString(slice)
    }

    fileReader.onload = async e => {
        const chunk = (e.target! as any).result
        spark.appendBinary(chunk)
        if (currentChunk < chunks - 1) {
            currentChunk = chunks - 1
            await loadNext()
        } else if (currentChunk == chunks - 1) {
            const identifier = spark.end()
            file.uniqueIdentifier = identifier
            file.resume()
        }
    }

    fileReader.onerror = function() {
        file.cancel()
    }

    await loadNext()
}

export function formatFileSize(value: number) {
    if (!value) {
        return '0 B'
    }
    const unitArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    let index = 0
    index = Math.floor(Math.log(value) / Math.log(1024))
    const maxIndex = unitArr.length - 1
    if (index > maxIndex) {
        index = maxIndex
    }
    let size: number | string = value / Math.pow(1024, index)
    //  保留的小数位数
    size = size.toFixed(2)
    return size + unitArr[index]
}

function computedFileSize(file: FileList | CustomFile | CustomFile | CustomFile[]) {
    function isFileList(data: FileList | CustomFile | CustomFile | CustomFile[]): data is FileList {
        return (data as FileList).length !== undefined
    }
    function isCustomFileList(data: FileList | CustomFile | CustomFile | CustomFile[]): data is CustomFile[] {
        return (data as FileList).length !== undefined
    }
    if (isFileList(file) || isCustomFileList(file)) {
        let size = 0
        for (let i = 0; i < file.length; i++) {
            size += file[i].size
        }
        return size
    } else {
        return file.size
    }
}
export interface CustomFile {
    size: number
    [key: string]: any
}

export function loadScript(url: string, func: string) {
    const head = document.head || document.getElementsByTagName('head')[0]
    const script = document.createElement('script')
    script.src = url + `/?callback=${func}`
    head.insertBefore(script, null)
}

export async function preTransferHandler(params: {
    files: FileList | File | CustomFile | CustomFile[]
    threshold: number
    url?: string
    transType: 'upload' | 'download'
}) {
    const { files, threshold, url, transType } = params
    const size = computedFileSize(files)
    const typeName = transType === 'upload' ? '上传' : '下载'
    if (size > threshold) {
        // todo test
        try {
            const downloadAppUrl = window.location.origin + '/desktop/heyTap_ait.zip'
            await MessageBox.confirm(
                `<div class="trans">
        <p style="color:#000;font-size:15px;margin-bottom:8px;font-weight:bold">文件已经超过${formatFileSize(
        threshold
    )}，推荐使用客户端进行${typeName}</p>
        <p style="font-size:8px">使用网页${typeName}大文件时间较长，可能导致文件${typeName}失败 </p>
        <p style="font-size:8px;">没有客户端？<a style="color:#23c4a6;" href="${downloadAppUrl}" download target="_blank">立即下载<a/></p>
        </div>`,
                '大文件传输',
                {
                    distinguishCancelAndClose: true,
                    cancelButtonText: `继续${typeName}`,
                    confirmButtonText: `客户端${typeName}`,
                    dangerouslyUseHTMLString: true,
                    customClass: 'transbox',
                }
            )
            const _url = url ? url : window.location.href
            protocolCheck(
                `Ait://file-system?fs_url=${_url}`,
                function() {
                    MessageBox.confirm(`<div style="color:#999;font-size:14px;">若无客户端，
                    点击此处<a style="color:#23c4a6;" href="${downloadAppUrl}" target="_blank" download >下载 </a></div>`,'未识别到客户端',{
                        dangerouslyUseHTMLString: true,
                        showCancelButton: false,
                        closeOnClickModal: false,
                    }).catch(err => {
                        console.log(err)
                    })
                },
                function() {
                    (window as any).connectTimes = 1
                    const timer = setInterval(() => {
                        if ((window as any).connectTimes >= 6) {
                            clearInterval(timer)
                            return
                        }
                        loadScript('http://localhost:33312', 'successHandler')
                        ;(window as any).connectTimes++
                    }, 1000)
                    ;(window as any).connectDesktopTimer = setTimeout(() => {
                        Message({
                            type: 'info',
                            message: '启动失败，请稍后重试',
                        })
                        ;(window as any).connectDesktopTimer && clearTimeout((window as any).connectDesktopTimer)
                    }, 6000)
                }
            )
            // window.location.href = `Ait://file-system?fs_url=${_url}`
            return false
        } catch (error) {
            console.log(error)
            if (error === 'cancel') {
                return true
            }
            return false
        }
    } else {
        return true
    }
}

export interface ElectronFile {
    // chunkNum: 678
    id: string
    identifier: string
    name: string
    size: number
    type: string
    chunkNum: number
    [key: string]: any
}
export async function electronDownload(file: ElectronFile, router: VueRouter, atSharePage?: boolean) {
    const res = await (window as any).Ait.fileSystem.addDownloadFile(file)
    if (res.data) {
        Message.success('文件下载中，前往下载列表查看')
        if (atSharePage) {
            router.push('/taskList')
        }
    }
}

export function getDesktopUrl(params) {
    const origin = window.location.origin
    const pathName = window.location.pathname
    const search = window.location.search
    let query = ''
    if (search) {
        query = search + '&fs_download_params=' + params
    } else {
        query = `?fs_download_params=${params}`
    }
    return `${origin}${pathName}${query}`
}

export function getUrlArgs() {
    const args: { [key: string]: any } = {}
    const query = location.search.substring(1)
    const pairs = query.split('&')
    for (let i = 0; i < pairs.length; i++) {
        const pos = pairs[i].indexOf('=')
        if (pos == -1) continue
        const name = pairs[i].substring(0, pos)
        let value = pairs[i].substring(pos + 1)
        value = decodeURIComponent(value)
        args[name] = value
    }
    return args
}
export function getEnv(): string {
    const host = location.hostname
    if (host.includes('dev')) return 'dev'
    else if (host.includes('test')) return 'test'
    return 'prod'
}

export function copyToClipboard(textToCopy: string) {
    if (navigator.clipboard && window.isSecureContext) {
        return  new Promise((res, rej) => {
            navigator.clipboard.writeText(textToCopy) ? res() : rej()
        })
    } else {
        let textArea = document.createElement('textarea')
        textArea.value = textToCopy
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        return new Promise((res, rej) => {
            document.execCommand('copy') ? res() : rej()
            textArea.remove()
        })
    }
}

export function findIsManager(manageTopIds: string[], dirId: string) {
    try {
        return (manageTopIds && manageTopIds.includes(dirId)) || false
    } catch (error) {
        console.log(error)
        return false
    }
}

const CodeKey = 'SSO_JS_FMS_CODE'
const TokenKey = 'SSO_JS_FMS_TOKEN'

export function getToken() {
    return Cookies.get(CodeKey)
}

export function setToken(token) {
    return Cookies.set(CodeKey, token)
}

export function removeToken(attributes = {}) {
    Cookies.remove(CodeKey, attributes)
    Cookies.remove(TokenKey, attributes)
}
export function removeUserToken(){
    Cookies.remove('JS_FMS_USER', { domain: '.ait.wanyol.com' })
}

export function parseLocation(location = window.location.href) {
    try {
        return new URL(location).search
            .substr(1)
            .split('&')
            .reduce((searchParams, curKV) => {
                const [k, v] = curKV.split('=').map(decodeURIComponent)
                searchParams[k] = v
                return searchParams
            }, {})
    } catch (error) {
        console.error(error.message)
        return {}
    }
}
